// © Microsoft Corporation. All rights reserved.

/**
 * This will decide whether to create Alert for this app error or no alert. This can generate IcM ticket.
 * Alerts ones are tracked at http://aka.ms/AppErrors
 * NoAlerts will have separate tab just next to Errors aka Warnings. IcM ticket won't be generated when NoAlert is set.
 */
export enum Severity {
    /**
     * This is app error with default severity
     */
    Alert,

    /**
     * This is app warning
     */
    NoAlert,

    /**
     * This app error has high user impact
     */
    HighImpact,

    /**
     * This is fatal app error
     */
    Critical
}